<template>
  <div class="bg_white">
    <div v-if="isShow" class="">
      <div class="mt24 pl20 pr20 pb24">
        <h2 class="cancellation_title text_blue ab c5a">解約する前に<br>必ずご確認ください。</h2>

        <div v-if="!canceled" class="contents center">
          <div v-if="responseStatus" class="mt16">
            <p class="contents_text ab text_blue large">解約を申請しました。</p>
          </div>
        </div>
        <div v-else class="contents center">
          <p class="contents_text ab large">既に解約申請済みです。<br>申請日： {{ requestDate }}</p>
        </div>

        <div class="contents">
          <ol class="contents_list ab">
            <li class="contents_item">以下の「解約する」ボタンを押すと、ナチュラリープラス会員の解約となります。</li>
            <li class="contents_item">解約はご登録内容を弊社にて確認いたしますので、約1週間ほどでお手続き完了いたします。<br>解約のお手続き完了後、後日「解約完了のご案内」をご郵送いたします。</li>
            <li class="contents_item">解約した場合、ナチュラリープラス会員としての一切の権利がなくなります。</li>
            <li class="contents_item">解約の取り消しはできませんのでご注意ください。</li>
            <li class="contents_item">BC001およびBC002以降の全てのポジションが解約となりますのでご注意ください。なお、BC002以降のみ解約する場合は弊社までお問い合わせください。</li>
            <li class="contents_item">「口座引落し払い」または「クレジットカード払い」をご利用の場合、解約のお手続き完了<br>後にお引き落としまたは決済されることがありますが、後日、全額返金させていただきます。</li>
            <li class="contents_item">クーリング・オフをご希望の場合は、<a href="https://www.secure-cloud.jp/sf/business/sp/1666169749eSgggkZF?openExternalBrowser=1" class="cooling_off text_blue">コチラ</a>より申請してください。</li>
          </ol>
          <div class="again mt24">
            <h2 class="again_title ab">【再登録する場合】</h2>
            <p class="again_text mt16"><span class="ab error_text">解約のお手続きが完了した日より6カ月経過しなければ再登録はできません。</span>再登録する場合は、新たに新規の会員登録申請を行う必要があり、登録に係る費用のお支払いが必要です。また、元のポジションに戻ることはできません。</p>
          </div>
        </div>

        <div v-if="!canceled" class="contents center">
          <div v-if="!responseStatus" class="mt32">
            <button @click="modalOpen()" :class="[isDisable ? 'disable' : 'active']" :disabled="isDisable" class="btn btn_blue ab mt16" type="button" name="button">解約する</button>
          </div>
          <p class="error_text ab">{{ errorDescription }}</p>
        </div>

        <div class="contact mt24">
          <p class="contact_title">お問い合わせ先</p>
          <p class="contact_text">メール：<a href="mailto:info@naturally-plus.co.jp" class="">info@naturally-plus.co.jp</a></p>
          <p class="contact_text">コールセンター：<a href="tel:0120-989-329" class="">0120-989-329</a></p>
          <p class="contact_text">受付時間：平日10時～18時<br>（土・日・祝日休み）</p>
        </div>

      </div>
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
    <Loading v-show="isLoading" />
    <DialogModal
      v-show="isModal"
      :message="modalMessage"
      @modalClose="modalClose"
      @modalCloseTransition="modalCloseTransition"
     />
  </div>
</template>

<script>
import Check from '@/model/getToken';
import Account from '@/components/api/account/cancel';
import Loading from '@/components/common/Loading';
import DialogModal from '@/components/common/DialogModal';

export default {
  components: {
    Loading,
    DialogModal
  },
  data() {
    return {
      isShow: true,
      isLoading: false,
      canceled: true,
      requestDate: '',
      isDisable: false,
      errorDescription: '',
      responseStatus: false, // 解約成功ならtrue
      isModal: false,
      modalMessage: 'ナチュラリープラス会員の解約申請をします。<br>本当によろしいですか？<br><span class="small">※約1週間ほどで解約のお手続きが完了いたします。</span>',
    }
  },
  methods: {
    modalOpen() {
      this.isModal = true;
    },
    modalClose() {
      this.isModal = false;
    },
    modalCloseTransition() {
      this.cancel();
    },
    async apiGetStatus() {
      await Account.getStatus().then((val) => {
        console.log(val);
        this.canceled = val.canceled;
        this.requestDate = val.requestDate;
      });
    },
    async cancel() {
      this.isLoading = true;
      this.isDisable = true;
      this.errorDescription = '';
      console.log('解約申し込み');
      await Account.cancel().then((val) => {
        this.isLoading = false;
        this.isModal = false;
        console.log(val);
        this.errorDescription = val.errorDescription;
        this.modalMessage = val.errorDescription;
        if(val.resultStatus == 'OK') {
          this.responseStatus = true;
        } else {
          this.isDisable = false;
          this.responseStatus = false;
        }
      });
    },
    initialized() {
      this.isLoading = false;
      this.canceled = false;
      this.requestDate = '';
      this.isDisable = false;
      this.errorDescription = '';
    },
  },
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.initialized();
      this.apiGetStatus();
    } else {
      this.isShow = false;
    }
  },
}
</script>

<style lang="css" scoped>
.error_text {
  color: red;
}
.text_blue {
  color: #00AEEF;
}
.cancellation_title {
  text-align: center;
}
.contents {
  margin-top: 24px;
}
.contents.center {
  text-align: center;
}

ol.contents_list {
  list-style-type: decimal;
  list-style: auto;
  margin-left: 16px;
}
.contents_list {
  font-size: 14px;

}

.again_title {
  font-size: 16px;
}

.again_text {
  font-size: 14px;
}

.contact {
  text-align: center;
}
.cooling_off {
  border-bottom: 1px solid #000;
}
.large {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/member/contract/Cancellation.vue